import { createRoute, lazyRouteComponent } from "@tanstack/react-router";
import { rootRoute } from "./root";

export const reservationsVoucherRoute = createRoute({
  path: "/reservations/$hashedId/voucher",
  getParentRoute: () => rootRoute,
  component: lazyRouteComponent(() => import("../pages/reservations-voucher")),
});
